import { useEffect } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { MotoGallery } from './components/MotoGallery';
import { Testimonials } from './components/Testimonials';
import { DeliveryCarousel } from './components/DeliveryCarousel';
import { Guarantees } from './components/Guarantees';
import { PaymentInfo } from './components/PaymentInfo';
import { Footer } from './components/Footer';
import { OfferPopup } from './components/OfferPopup';
import { useStore } from './stores/appStore';
import { motosMock } from './data/mockData';

function App() {
  const { setMotos } = useStore();

  useEffect(() => {
    // Carregar motos mockados inicialmente
    setMotos(motosMock);
    
    // Verificar se há dados no localStorage
    const savedMotos = localStorage.getItem('motos');
    if (savedMotos) {
      setMotos(JSON.parse(savedMotos));
    }
  }, [setMotos]);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <Hero />
      <MotoGallery />
      <Testimonials />
      <DeliveryCarousel />
      <Guarantees />
      <PaymentInfo />
      <Footer />
      <OfferPopup />
    </div>
  );
}

export default App;